<script lang="ts" setup>
import { useQuery } from "@tanstack/vue-query";
import Content from "~/components/kentico/Content.vue";
import { useSettings } from "~/store/settings";
import { IKenticoResponse } from "~/types/kentico/content";
import api from "~/utils/auth/api";
import { sitemapMatcher } from "~/utils/sitemaps/sitemapMatcher";
const config = useRuntimeConfig();
const settings = useSettings();
import calculateSitemapPath from "~/utils/calculateSitemapPath";

const route = useRoute();
interface Props {
	class?: string;
}

defineProps<Props>();

const reactiveContentPath = computed(() => {
	try {
		const routeFilterOptions = calculateSitemapPath();
		const filteredData = sitemapMatcher({ sitemap: settings.getSitemap, routeFilterOptions });

		if (filteredData && route.params.tab) {
			const newRouteFilterOptions = { A: route.params.tab };
			const filteredNew = sitemapMatcher({ sitemap: settings.getSitemap, routeFilterOptions: newRouteFilterOptions });
			if (filteredNew) {
				return filteredNew.P;
			}
			return filteredData?.P;
		}

		if (filteredData?.A === "home") {
			return filteredData?.P + "/home";
		}

		return filteredData?.P;
	} catch (e) {
		return undefined;
	}
});

const { data } = useQuery<IKenticoResponse>({
	queryKey: [reactiveContentPath.value],
	queryFn: () =>
		api({
			type: "content",
			url: `?host=${config.public.kenticoDomain.replace(/^https?:\/\//, "")}&route=${reactiveContentPath.value}&lang=${settings.locale}`,
		}),
});
</script>

<template>
	<ClientOnly>
		<div :class="class">
			<Content v-if="data" :kenticoResponse="data" />
		</div>
	</ClientOnly>
</template>
